import { Logo } from '@/assets';
import { cn } from '@/lib/utils';

const PoweredBy = ({ className }: { className?: string }) => {
  return (
    <a
      href="https://www.123jobs.com/"
      target="_blank"
      rel="noopener noreferrer"
      className={cn('flex items-center justify-center gap-1.5 transition-opacity hover:opacity-80', className)}
    >
      <span className="text-xs font-bold uppercase tracking-wider text-[#9aa0a8]">
        Powered by
      </span>
      <Logo className="size-4" />
      <span className="text-sm font-semibold text-[#6b7079]">
        123JOBS.COM<sup className="align-super text-[8px]">TM</sup>
      </span>
    </a>
  );
};

export default PoweredBy;
